import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { User, LogOut, ChevronDown, Settings } from 'lucide-react'
import { Link } from 'react-router-dom'
import useAuth from '../hooks/useAuth'

export default function UserMenu() {
  const [isOpen, setIsOpen] = useState(false)
  const { user, signOut } = useAuth()

  const handleSignOut = async () => {
    await signOut()
    setIsOpen(false)
  }

  if (!user) return null

  return (
    <div className="relative z-[9999]">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg border border-light-gray-alt dark:border-deep-purple/50 bg-light-gray/50 dark:bg-deep-purple/20 hover:bg-light-gray dark:hover:bg-deep-purple/40 text-soft-black dark:text-white transition-all duration-200"
      >
        <div className="w-6 h-6 rounded-full bg-darling-lilac/20 dark:bg-darling-lilac/30 flex items-center justify-center">
          <User className="h-3.5 w-3.5 text-darling-lilac" />
        </div>
        <span className="hidden sm:inline text-sm font-exo font-medium">
          {user.email?.split('@')[0]}
        </span>
        <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            {/* Backdrop */}
            <div
              className="fixed inset-0 z-[9998]"
              onClick={() => setIsOpen(false)}
            />
            
            {/* Menu */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: -10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: -10 }}
              className="absolute right-0 top-full mt-2 w-48 bg-white dark:bg-soft-black rounded-xl border border-light-gray-alt dark:border-deep-purple/50 shadow-2xl z-[9999] overflow-hidden"
              style={{ 
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.05)' 
              }}
            >
              <div className="p-3 border-b border-light-gray-alt dark:border-deep-purple/30">
                <p className="text-sm font-exo font-medium text-soft-black dark:text-white">
                  {user.email}
                </p>
                <p className="text-xs text-soft-black/60 dark:text-light-gray/70 font-exo">
                  Embaixador CRO Brasil
                </p>
              </div>
              
              <Link
                to="/profile"
                onClick={() => setIsOpen(false)}
                className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm font-exo font-medium text-soft-black dark:text-white hover:bg-light-gray dark:hover:bg-deep-purple/20 transition-colors"
              >
                <Settings className="h-4 w-4" />
                Meu Perfil
              </Link>
              
              <button
                onClick={handleSignOut}
                className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm font-exo font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
              >
                <LogOut className="h-4 w-4" />
                Sair
              </button>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  )
}